<template>
  <ExibicaoInputText
    v-if="exibeComoChip"
    v-model:text="text"
    :filtro="filtro"
    :campo="filtro"
    @excluded="excluirFiltro"
    @aplicarFiltro="aplicarFiltro"
    :path="path"
  />
  <InputText
    v-else
    :filtro="filtro"
    @aplicarFiltro="aplicarFiltro"
    v-model:text="text"
    :path="path"
  />
</template>
<script>
import ExibicaoInputText from '../../components/ExibicaoInputText.vue';
import InputText from '../../components/InputText.vue';
import mixinFiltro from '../../mixins/mixinFiltro';
export default {
  emits: ['excluirFiltro'],
  props: {
    filtro: {
      type: Object,
      required: true
    },
    path: {
      type: String,
      required: true
    }
  },
  components: {
    InputText,
    ExibicaoInputText
  },
  mixins: [mixinFiltro],
  computed: {
    exibeComoChip() {
      return this.filtro.parametros?.exibicao === 'chip';
    }
  },
}

</script>
